import type { ReactNode } from 'react';

/* Секция галереи: якорь, заголовок страницы, подводка. */
export function Section({
  id,
  title,
  lead,
  children,
}: {
  id: string;
  title: string;
  lead: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className="flex scroll-mt-20 flex-col gap-6">
      <header>
        <h2 className="type-title text-fg">{title}</h2>
        <p className="mt-1 max-w-3xl text-sm text-fg-muted">{lead}</p>
      </header>
      {children}
    </section>
  );
}

/* Подзаголовок внутри секции. */
export function SubTitle({ children }: { children: ReactNode }) {
  return <h3 className="type-heading text-fg">{children}</h3>;
}

/* Подпись-код под образцом. */
export function Code({ children }: { children: ReactNode }) {
  return <code className="rounded-xs bg-muted px-1 py-0.5 font-mono text-2xs text-fg-muted">{children}</code>;
}
